
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-company/[slug]",
      function () {
        return require("private-next-pages/ai-company/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-company/[slug]"])
      });
    }
  